import { ChangeEvent } from 'react'
import './Select.css'

export interface SelectOption {
  value: string
  label: string
}

export interface SelectProps {
  label: string
  name: string
  options: SelectOption[]
  value?: string
  onChange?: (value: string) => void
  required?: boolean
  error?: string
  id?: string
}

function Select({
  label,
  name,
  options,
  value = '',
  onChange,
  required = false,
  error,
  id,
}: SelectProps) {
  const selectId = id || name

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange(e.target.value)
    }
  }

  return (
    <div className={`select-wrapper ${error ? 'has-error' : ''}`}>
      <label htmlFor={selectId} className="select-label">
        {label}
        {required && <span className="select-required" aria-hidden="true">*</span>}
      </label>
      <select
        id={selectId}
        name={name}
        value={value}
        onChange={handleChange}
        className="select-input"
        aria-required={required}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? `${selectId}-error` : undefined}
      >
        <option value="" disabled>
          Select an option
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <span id={`${selectId}-error`} className="select-error" role="alert">
          {error}
        </span>
      )}
    </div>
  )
}

export default Select